    <div class='sticky-container' [ngStyle]="bannerStyle">
        <ng-content select="customStickyBody"></ng-content>
    </div>
